<template>
  <div class="calculator-area sticky">
    <div id="payment">
      <p class="title"><i class="fal fa-usd-circle"></i> 결제 금액 계산</p>
      <div class="calculator-wrap">
        <MainGoodsCalculate/>
        <SubGoodsCalculate/>
        <CalculateResult
            @show-estimate="showEstimate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MainGoodsCalculate from "@/components/step1/Calculate/MainGoodsCalculate"
import SubGoodsCalculate from "@/components/step1/Calculate/SubGoodsCalculate"
import CalculateResult from "@/components/step1/Calculate/CalculateResult"

export default {
  name: "PriceCalculate",
  components:{
    MainGoodsCalculate,
    SubGoodsCalculate,
    CalculateResult,
  },
  methods: {
    showEstimate(){
      this.$emit('show-estimate')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "/src/assets/scss/base/variable";

// 결제 금액 계산
.calculator-area {
  float: right;
  width: 310px;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    font-size: 18px;
    i {
      margin-right: 9px;
      font-size: 22px;
    }
  }
  .calculator-wrap {
    padding: 20px 30px 40px 30px;
    border-radius: 3px;
    background: #f1f7fa;
    border: 1px solid #d3d3d3;
    ::v-deep table {
      border-collapse: collapse;
      width: 100%;
      tbody{
        border-bottom: 1px solid #d3d3d3;
        border-collapse: separate;
      }
      tbody:before{
        content: '';
        display: block;
        height: 10px;
      }
      th, td {
        padding: 15px 0;
        border-top: 1px solid #d3d3d3;
      }
      tr {
        &:first-child th,
        &:first-child td {
          padding-top: 0;
          border-top: none;
          font-weight: 500;
        }
      }
      th {
        color: #333;
        text-align: left;
        font-weight: 500;
      }
      td {
        text-align: right;
        font-weight: 300;
      }
      .add_price th,
      .add_price td {
        padding: 0 0 15px;
        background: transparent;
        font-size: 14px;
        font-weight: 300;
        border-top: none;
      }
      .add_price.emphasize th,
      .add_price.emphasize td {
        color: $w-orange;
      }
    }
    ::v-deep .total-pay {
      padding: 60px 0 20px;
      font-size: 14px;
      color: #3090D6;
      text-align: right;
      .pay {
        font-size: 30px;
      }
    }
  }
  @supports (position: sticky) or (position: -webkit-sticky) {
    &.sticky {
      position: -webkit-sticky; /* 사파리 브라우저 지원 */
      position: sticky;
      top: 100px;
    }
  }
  .calculator-area {
    @supports (position: sticky) or (position: -webkit-sticky) {
      &.sticky {
        position: -webkit-sticky; /* 사파리 브라우저 지원 */
        position: sticky;
        top: 100px;
      }
    }
    float: right;
    width: 310px;
    > .title {
      padding: 30px 0 20px;
      font-size: 18px;
      i {
        margin-right: 9px;
        font-size: 22px;
      }
    }
    .calculator-wrap {
      padding: 30px 40px;
      background: #F0F4F9;
      border-radius: 3px;
      ::v-deep table {
        width: 100%;
        th, td {
          padding: 15px 0;
          border-bottom: 1px solid #E5E5E5;
        }
        tr {
          &:first-child th,
          &:first-child td {
            padding-top: 0;
          }
        }
        th {
          color: #333;
          text-align: left;
          font-weight: 500;
        }
        td {
          text-align: right;
          font-weight: 300;
          span {
            &.text-orange {color: #F7741E;}
          }
        }
      }
      ::v-deep .total-pay {
        padding: 60px 0 20px;
        font-size: 14px;
        color: #3090D6;
        text-align: right;
        .pay {
          font-size: 30px;
        }
      }
      ::v-deep .btn-payment {
        button {
          display: inline-block;
          width: 100%;
          height: 50px;
          line-height: 50px;
          background: #3090D6;
          border-radius: 3px;
          color: #fff;
          &:hover {background-color: #34A0EF;}
        }
      }
      ::v-deep .btn-history-back {
        margin-top: 10px;
        button {
          display: inline-block;
          width: 100%;
          height: 48px;
          line-height: 48px;
          background: $w-white;
          border: 1px solid #E5E5E5;
          border-radius: 3px;
          color: #333;
          &:hover {border-color: $w-333;}
        }

      }
    }
  }
}
</style>